import React from 'react'
import Box from '@mui/material/Box'
import { brandBlue, brandOrange, headingFont } from 'src/ui/theme/tokens'

export default function Brand({ compact = false }: { compact?: boolean }): JSX.Element {
  return (
    <Box
      component="span"
      className="rt-brand"
      display="inline-flex"
      alignItems="center"
      gap={0.5}
      sx={{ whiteSpace: 'nowrap', userSelect: 'none' }}
    >
      <Box
        component="img"
        src="/brand/tile-mates.svg"
        alt=""
        width={compact ? 44 : 52}
        height={compact ? 44 : 52}
        sx={{ transform: 'translateY(-3px)' }}
      />
      <Box
        component="span"
        data-rt-display
        sx={{
          fontFamily: headingFont,
          fontWeight: 800,
          fontSize: compact ? 26 : { xs: 26, sm: 32 },
          letterSpacing: '-.025em',
          lineHeight: 1,
          textShadow: 'none',
        }}
      >
        <Box component="span" sx={{ color: brandBlue }}>
          Rank
        </Box>
        <Box component="span" sx={{ color: brandOrange }}>
          Trivia
        </Box>
      </Box>
    </Box>
  )
}
